import React, {forwardRef, useCallback, useEffect, useRef, useState} from "react";
import flatpickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.min.css'
import 'flatpickr/dist/themes/dark.css'
import {decryptAndGetSessionVariable} from "./storageHelper";
import {useGridDate} from 'ag-grid-react';

export default forwardRef((props, ref) => {
    const [picker, setPicker] = useState(null);
    const refFlatPickr = useRef(null);
    const refInput = useRef();
    const dateRef = useRef();

    const onDateChanged = (selectedDates) => {
        const newDate = selectedDates[0];
        props.onDateChange(newDate);
    };

    useEffect(() => {
        setPicker(flatpickr(refFlatPickr.current, {
            onChange: onDateChanged,
            dateFormat: "F d, Y h:i:S K",
            wrap: true,
            enableTime: true,
            enableSeconds: true
        }));
    }, []);

    useEffect(() => {
        if (picker && picker.calendarContainer && picker.calendarContainer.classList) {
            picker.calendarContainer.classList.add('ag-custom-component-popup');
        }
    }, [picker]);

    useEffect(() => {
        if (picker) {
            refInput.current.setAttribute('placeholder', "yyyy-mm-dd");
        }
    }, [picker]);

    useEffect(() => {
        if (picker) {
            picker.setDate(props.date);
        }
    }, [props.date, picker]);

    const setInputPlaceholder = useCallback((placeholder) => {
        if (refInput.current) {
            refInput.current.setAttribute('placeholder', placeholder);
        }
    }, []);

    const setInputAriaLabel = useCallback((label) => {
        if (refInput.current) {
            refInput.current.setAttribute('aria-label', label);
        }
    }, []);

    useGridDate({
        setInputPlaceholder,
        setInputAriaLabel,
    });

    return (
        <div className="ag-input-wrapper custom-date-filter"  role="presentation" ref={refFlatPickr}>
            <input type="text" ref={refInput} data-input style={{ width: "100%" }} />
            <a className='input-button' title='clear' data-clear>
                <i className='fa fa-times'></i>
            </a>
        </div>
    );
});
export function dateFilterParametersInHeaderClientSideGrid () {
    return {
        defaultOption: "inRange",
        maxNumConditions: 2,
        filterOptions: ['equals', 'lessThan', 'greaterThan', 'inRange', 'blank', 'notBlank'],
        buttons: ["reset", "apply", "cancel"],
        comparator: function (filterLocalDate, cellValue) {
            return dateFilter(filterLocalDate, cellValue)
        }
    }
}
export function dateFilterParametersInHeaderSuppressSorting (maxNumFilterConditions=1) {
    return {
        suppressSorting: true,

        defaultOption: "inRange",
        filterOptions: ['equals', 'lessThan', 'greaterThan', 'inRange'],
        maxNumConditions: maxNumFilterConditions,
        buttons: ["reset", "apply", "cancel"],
        comparator: function (filterLocalDate, cellValue) {
            return dateFilter(filterLocalDate, cellValue)
        }
    }
}
export function dateFilter (filterLocalDate, cellValue){

    let test = new Date()
    let timezone = decryptAndGetSessionVariable("timezone")
    if(timezone === null || timezone === undefined){
        timezone = "Europe/London" //default to london gmt time if timezone is null
    }
    let testSessionTime = (new Date(Date.parse(test.toLocaleString('en-US', {
        timeZone: timezone
    }))));

    let sessionTZOffset = Math.ceil((testSessionTime - test) / 36e5) * 60 * 60 * 1000;
    let browserTZOffset = filterLocalDate.getTimezoneOffset() * 60 * 1000

    cellValue = Math.floor((Date.parse(cellValue) - browserTZOffset)/1000)
    filterLocalDate = (filterLocalDate.getTime() - (sessionTZOffset) - browserTZOffset)/1000

    if (filterLocalDate === cellValue) {
        return 0;
    }

    if (cellValue < filterLocalDate) {
        return -1;
    }

    if (cellValue > filterLocalDate) {
        return 1;
    }
}

/*
    Day-only date filter for columns that store dates rounded to midnight UTC (e.g. dateDayRounded).
    Compares year/month/day only — no time, no timezone offset math — so inRange/equals/etc.
    work correctly when the cell value is always 00:00:00 UTC.
*/
export function dateFilterParametersInHeaderDayOnly(maxNumConditions=2) {
    return {
        defaultOption: "inRange",
        filterOptions: ['equals', 'lessThan', 'greaterThan', 'inRange', 'blank', 'notBlank'],
        maxNumConditions: maxNumConditions,
        buttons: ["reset", "apply", "cancel"],
        comparator: function (filterLocalDate, cellValue) {
            if (!cellValue) return -1;
            // Strip time from both sides — compare year/month/day only
            const cellDate = new Date(cellValue);
            const cellDay = Date.UTC(cellDate.getUTCFullYear(), cellDate.getUTCMonth(), cellDate.getUTCDate());
            const filterDay = Date.UTC(filterLocalDate.getFullYear(), filterLocalDate.getMonth(), filterLocalDate.getDate());
            if (cellDay === filterDay) return 0;
            if (cellDay < filterDay) return -1;
            return 1;
        }
    }
}